import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosClient from "../../../services/api/axiosInstance";
import { TokenUsageHistory } from "../models";

export const TOKEN_USAGE_HISTORY_QUERY_KEY = "TokenUsageHistory";

export const useTokenUsageHistory = (customerId: string) =>
  useQuery<TokenUsageHistory>({
    queryKey: [TOKEN_USAGE_HISTORY_QUERY_KEY, customerId],
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<TokenUsageHistory>(
        `/api/v1/ai-settings/${customerId}/token-usage/last-12-months`,
        {
          signal,
        }
      );

      return response?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 60000,
  });
